import { IOpenedSetAction } from './types';
import { AT_OPENED_SET } from './constants';

export const openedSet = (
    isOpened: boolean
): IOpenedSetAction => ({
    type: AT_OPENED_SET,
    isOpened
});
